<br />
<section *ngIf="processing">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
  </mat-progress-bar>
</section>
<div fxLayout="row wrap" class="matero-row">
  &nbsp;&nbsp;
  <button mat-raised-button color="primary" title="Add Sample" (click)="addSample(0)" [disabled]="authService.isReadOnly()"><mat-icon>add</mat-icon> Add Sample</button>
</div>
<br>
<mat-card>
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-row" style="overflow-x: auto;">
    <strong class="noMarginHeader">Results ({{resultSize}})</strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTable($event)" placeholder="Filter Results" matInput />
    </mat-form-field>
    &nbsp;&nbsp;&nbsp;&nbsp; <a (click)="loadSamples()"><mat-icon>refresh</mat-icon> </a>
    <br />
    <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
      <mat-row>Results ({{resultSize}})</mat-row>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <ng-container matColumnDef="sampleId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Sample Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a (click)="editSample(result.sampleId)" title="Edit Sample {{result.sampleId}}">{{result.sampleId}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="createDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Sample Date</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.createDate}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="collectionDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Analysis Date</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.collectionDate}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="retOrNot">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.retOrNot}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="qA">
        <mat-header-cell *matHeaderCellDef mat-sort-header>QA</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.qa}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="numberofSampleTests">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Sample Tests</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.numberofSampleTests}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="hasExceedances">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Has Exceedances</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <span *ngIf="result.hasExceedances">Yes</span>
          <span *ngIf="!result.hasExceedances">No</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="voucherId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Voucher</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.voucherId}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="highestNitrateTestResult">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 180px;">Nitrate Result</mat-header-cell>
        <mat-cell *matCellDef="let result" style="min-width: 180px;">{{result.highestNitrateTestResult}} mg/L</mat-cell>
      </ng-container>
      <ng-container matColumnDef="tier">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Tier</mat-header-cell>
        <mat-cell *matCellDef="let result">{{result.tier}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <span [hidden]="authService.isReadOnly()">
            <a href="javascript:void(0)" (click)="editSample(result.sampleId)" title="Edit Sample {{result.sampleId}}">
              <mat-icon>edit</mat-icon>
            </a>
            <a href="javascript:void(0)" (click)="addSample(result.sampleId)" title="Duplicate Sample {{result.sampleId}}">
              <mat-icon>file_copy</mat-icon>
            </a>
          </span>
          &nbsp;&nbsp;
          <span [hidden]="authService.isReadOnly()">
            <a href="javascript:void(0)" (click)="deleteSample(result.sampleId)" title="Delete Sample {{result.sampleId}}">
              <mat-icon>delete</mat-icon>
            </a>
          </span>
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>